import { ClientApp } from "./ClientApp.ts";

const root = document.getElementById("client-root")!;
const loadingEl = document.getElementById("client-loading")!;
const loadingMsg = document.getElementById("client-loading-msg")!;
const loadingRing = document.getElementById("client-progress-ring") as SVGCircleElement | null;
const errorEl = document.getElementById("client-error") as HTMLElement;
const errorMsg = document.getElementById("client-error-msg")!;

const RING_CIRCUMFERENCE = 2 * Math.PI * 44; // r=44 in SVG

function setProgress(fraction: number): void {
  if (!loadingRing) return;
  const offset = RING_CIRCUMFERENCE * (1 - fraction);
  loadingRing.style.strokeDashoffset = String(offset);
}

function showError(msg: string): void {
  loadingEl.style.display = "none";
  errorEl.style.display = "flex";
  errorMsg.textContent = msg;
}

const pathParts = window.location.pathname.split("/").filter(Boolean);
const token = pathParts[1] ?? "";

if (!token) {
  showError("No share token found in URL.");
} else {
  loadingMsg.textContent = "Fetching tour data…";
  setProgress(0.05);

  fetch(`/api/client/${encodeURIComponent(token)}/data`)
    .then(async (res) => {
      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(res.status === 403 ? "Link expired or invalid." : (text || `Server error ${res.status}`));
      }
      return res.json() as Promise<{ ic_project_id: string; composition: unknown }>;
    })
    .then((data) => {
      loadingMsg.textContent = "Loading 3D model…";
      setProgress(0.1);

      const app = new ClientApp(
        root,
        token,
        data.composition as import("../types.ts").HouseComposition,
      );

      app.onProgress = (fraction, label) => {
        setProgress(0.1 + fraction * 0.9);
        if (label) loadingMsg.textContent = label;
        if (fraction >= 1) {
          // Brief delay so the ring finishes filling before hiding
          setTimeout(() => { loadingEl.style.display = "none"; }, 400);
        }
      };
    })
    .catch((err: Error) => {
      showError(err.message || "Failed to load tour.");
    });
}
